import React, { useState, useEffect } from "react";
import Button from "@material-ui/core/Button";
import { makeStyles } from "@material-ui/styles";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import Hidden from "@material-ui/core/Hidden";
import { Router, Link } from "@reach/router";
import Divider from "@material-ui/core/Divider";
import { withSnackbar } from "notistack";
import SERVER_ADDRESS from "../../../config";
import { testNames, fullGrade, testNameList, simpleFullGrade } from "./config";
import {
  Radar,
  RadarChart,
  PolarGrid,
  Legend,
  PolarAngleAxis,
  PolarRadiusAxis
} from "recharts";

const useStyles = makeStyles(theme => ({
  chart: {
    margin: "auto"
  }
}));

function getMaxGrade(grades) {
  let maxGrade;
  grades.forEach(grade => {
    if (!maxGrade || maxGrade.grade < grade.grade) {
      maxGrade = grade;
    }
  });
  return maxGrade;
}

function getMinGrade(grades) {
  let minGrade;
  grades.forEach(grade => {
    if (!minGrade || minGrade.grade > grade.grade) {
      minGrade = grade;
    }
  });
  return minGrade;
}

//  制图数据过滤
function maxMinGradeData(gradeData) {
  const maxGrade = [];
  testNameList.forEach(testName => {
    const thisTestGrade = gradeData.filter(
      grade => grade.test_type === testName
    );
    if (thisTestGrade.length > 0) {
      const hGrade = getMaxGrade(thisTestGrade);
      const lGrade = getMinGrade(thisTestGrade);
      maxGrade.push({
        subject: testName,
        Max: hGrade.grade,
        Min: lGrade.grade,
        fullMark: simpleFullGrade
      });
    } else {
      maxGrade.push({
        subject: testName,
        Max: 0,
        Min: 0,
        fullMark: simpleFullGrade
      });
    }
  });
  return maxGrade;
}

function RadarGradeChart(props) {
  const classes = useStyles();
  const { gradeData, averageGrade, teacherView } = props;
  const data = maxMinGradeData(gradeData);
  const dataWithAverage = data.map(dataItem => {
    return { ...dataItem, Average: averageGrade[dataItem.subject] };
  });
  return (
    <>
      {gradeData.length > 0 && (
        <RadarChart
          cx={250}
          cy={250}
          outerRadius={150}
          width={500}
          height={500}
          data={dataWithAverage}
          className={classes.chart}
        >
          <PolarGrid />
          <PolarAngleAxis dataKey="subject" />
          <PolarRadiusAxis angle={30} domain={[0, simpleFullGrade]} />
          <Radar
            name={teacherView ? "最高分" : "个人最高分"}
            dataKey="Max"
            stroke="#8884d8"
            fill="#8884d8"
            label
            fillOpacity={0.1}
          />
          <Radar
            name={teacherView ? "平均分" : "个人平均分"}
            dataKey="Average"
            stroke="#FF8042"
            fill="#FF8042"
            fillOpacity={0.2}
            label
          />
          <Radar
            name={teacherView ? "最低分" : "个人最低分"}
            dataKey="Min"
            stroke="#82ca9d"
            fill="#82ca9d"
            label
            fillOpacity={0.3}
          />

          <Legend />
        </RadarChart>
      )}
    </>
  );
}

export default RadarGradeChart;
